import { render, staticRenderFns } from "./PlayersList.vue?vue&type=template&id=8182efa4&scoped=true&"
import script from "./PlayersList.vue?vue&type=script&lang=js&"
export * from "./PlayersList.vue?vue&type=script&lang=js&"
import style0 from "./PlayersList.vue?vue&type=style&index=0&id=8182efa4&lang=scss&scoped=true&"
import style1 from "./PlayersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8182efa4",
  null
  
)

export default component.exports